import { sectionRenderer } from '@theme/section-renderer';

class SearchContentResultsReal extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.#loadResults();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  async #loadResults() {
    const { endpoint, query, resourceTypes, sectionId } = this.dataset;
    const target = this.querySelector('[data-search-content-results-target]');

    if (!endpoint || !query || !resourceTypes || !sectionId || !(target instanceof HTMLElement)) {
      this.hidden = true;
      return;
    }

    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', resourceTypes);
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][fields]', 'title,body');

    try {
      const sectionHTML = await sectionRenderer.getSectionHTML(
        sectionId,
        true,
        url,
        this.#controller.signal
      );

      if (this.#controller.signal.aborted) return;

      const parsedDocument = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const payload = parsedDocument.querySelector('[data-search-content-results-payload]');
      const resultCount = Number(payload?.getAttribute('data-result-count') ?? 0);

      if (!(payload instanceof HTMLElement) || resultCount === 0) {
        this.hidden = true;
        return;
      }

      target.replaceChildren(...Array.from(payload.childNodes, (node) => node.cloneNode(true)));
      target.setAttribute('aria-busy', 'false');
      this.dataset.loaded = 'true';
    } catch (error) {
      if (this.#controller.signal.aborted) return;

      this.hidden = true;
      console.warn('Related search results could not be loaded.', error);
    }
  }
}

if (!customElements.get('search-content-results-real')) {
  customElements.define('search-content-results-real', SearchContentResultsReal);
}
